import common from './common' // 公共接口模块
import login from './login' // 登录模块
import member from './member' // member模块
import doctorappointments from './doctorappointments' // 金牌医生模块
import medicineforchronic from './medicineforchronic' // 线上送药模块
import allpolicy from './allpolicy' // 全部保单
import queryhospital from './queryhospital' // 查询医院
import medicalrecords from './medicalrecords' // 就医记录
import claim from './claim' // 理赔模块
import preauthorize from './preauthorize' // 预授权模块
import selfpaymentamount from './selfpaymentamount' // 待缴自付额
import survey from './survey' // 满意度调查
import otherservice from './otherservice' // 其他服务
import bankcard from './bankcard' // 银行卡模块
import bxcard from './bxcard' // 保险卡模块
import walfare from './walfare' // 保险福利
import messagecenter from './messagecenter' // 消息中心
import incrementservice from './incrementservice' // 增值服务模块
import cashierdesk from './cashierdesk' // 收银台模块
import usercenter from './usercenter' // 个人中心
import fafuli from './fafuli' // 发福利模块
import worldCup from './world-cup' // 塔卡尔世界杯
import activities from './activities' // 活动中心
import otherSystem from './otherSystem' // 其他系统中转
const apis = {
  ...common,
  ...login,
  ...member,
  ...doctorappointments,
  ...medicineforchronic,
  ...allpolicy,
  ...queryhospital,
  ...medicalrecords,
  ...claim,
  ...preauthorize,
  ...selfpaymentamount,
  ...survey,
  ...otherservice,
  ...bankcard,
  ...bxcard,
  ...walfare,
  ...messagecenter,
  ...incrementservice,
  ...cashierdesk,
  ...usercenter,
  ...fafuli,
  ...worldCup,
  ...activities,
  ...otherSystem
}
export default apis
